export default __webpack_public_path__ + "static/brand-logo-white-da13fabb3ff83cbc83845245824c2215.svg";